import { render, staticRenderFns } from "./PublishConfirm.vue?vue&type=template&id=39e57c0c"
import script from "./PublishConfirm.vue?vue&type=script&lang=js"
export * from "./PublishConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports